export default __webpack_public_path__ + "static/media/timer.04c6bd71.svg";